/* eslint-disable react/self-closing-comp */
import React from 'react'
import { useQuery } from '@apollo/client'

import { useParams } from 'react-router'

import { Message, Header } from 'semantic-ui-react'

// material
import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'
import { getComplaint } from '../graphql/queries'
// Menu
import Menu from '../components/Menu'
import ClientMenuLeft from './common/ClientMenuLeft'
// components
import Page from '../components/Page'
import ComplaintView from '../components/complaint/ComplaintView'
import DisplayLoading from '../components/common/DisplayLoading'
import DisplayError from '../components/common/DisplayError'
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

export default function ClientComplaintViewPage() {
  // eslint-disable-next-line prefer-const
  let { confirmationId } = useParams()

  const { data, error, loading } = useQuery(getComplaint, {
    variables: { confirmation: confirmationId },
  })

  return (
    <RootStyle title="Détail de la plainte | Gestion des plaintes">
      <Menu />
      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          {' '}
          <Message>
            <Header as="h2" color="blue">
              Détail de la plainte
            </Header>
          </Message>
          <DisplayLoading loadingMessage={loading} iconName="circle notched" />
          <DisplayError errorMessage={error} />
          {data && data.getComplaint && (
            <ComplaintView complaint={data.getComplaint} />
          )}
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
